import { render, staticRenderFns } from "./courseList.vue?vue&type=template&id=45bce340&scoped=true"
import script from "./courseList.vue?vue&type=script&lang=js"
export * from "./courseList.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/course/courseList.css?vue&type=style&index=0&id=45bce340&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bce340",
  null
  
)

export default component.exports